import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PdfService {
  private _pdfApiUrl = `${environment.pdf}`;

  constructor(private _http: HttpClient) { }

  generatePdf(value: string, singlePage: boolean = false) {
    const params = new HttpParams().set('singlePage', singlePage.toString());
    return this._http.put(`${this._pdfApiUrl}/Generate`, value, {
      responseType: 'blob',
      params
    });
  }
  
  getDocumentLookupCode(category: string, id: any, queryParam?: string): Observable<any> {
    let url = `${environment.inventory}/GenerateLookupCode/${category}/${id}`;
    if (queryParam) {
      url += `?${queryParam.trim()}`;
    }
    return this._http.get(url);
  }

  getQuotePdfFromLookupCode(lookupCode: any): Observable<any>{
    return this._http.get(`${environment.public}/GenerarteItinerary/${lookupCode}`, {
      responseType: 'blob'
    });
  }

  getVoucherPdfFromLookupCode(lookupCode: any): Observable<any>{
    return this._http.get(`${environment.public}/GenerateVoucher/${lookupCode}`, {
      responseType: 'blob'
    });
  }

  getInvoicePdfFromLookupCode(lookupCode: any): Observable<any>{
    return this._http.get(`${environment.public}/GenerateInvoice/${lookupCode}`, {
      responseType: 'blob'
    });
  }
  
}
